import { BigNumber } from 'ethers';
import { isAddress } from 'ethers/lib/utils';

import { PurchaseError } from 'models/errors/purchase-error';

/**
 * Maximum safe amount for ERC1155 token amounts (2^128 - 1)
 */
const MAX_SAFE_AMOUNT = BigNumber.from(2).pow(128).sub(1);

/**
 * Validates that an Ethereum address is properly formatted
 * @throws PurchaseError if address is invalid
 */
export function validateEthereumAddress(address: string, fieldName = 'Address'): void {
  if (!address || !isAddress(address)) {
    throw PurchaseError.invalidSellerAddress(address);
  }
}

/**
 * Validates that a token amount doesn't exceed safe limits
 * @throws PurchaseError if amount is too large
 */
export function validateTokenAmount(amount: number | string): void {
  try {
    const amountBN = BigNumber.from(amount);
    if (amountBN.gt(MAX_SAFE_AMOUNT)) {
      throw PurchaseError.amountOverflow();
    }
    if (amountBN.lt(0)) {
      throw new Error('Amount cannot be negative');
    }
  } catch (error) {
    if (error instanceof PurchaseError) {
      throw error;
    }
    throw new Error(`Invalid amount: ${amount}`);
  }
}

/**
 * Validates a price string is a valid positive number
 */
export function validatePrice(price: string | number): void {
  const priceNum = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(priceNum) || priceNum <= 0) {
    throw new Error(`Invalid price: ${price}`);
  }
}
